'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _UserOutlined = _interopRequireDefault(require('./lib/icons/UserOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _UserOutlined;
exports.default = _default;
module.exports = _default;